import React from "react";

export const SessionField = ({
  type = "text",
  name,
  id,
  placeholder,
  autoComplete,
  autoFocus,
  required,
  className,
  ...rest
}) => (
  <input
    type={type}
    name={name}
    id={id}
    placeholder={placeholder}
    className={`session-field${className ? ` ${className}` : ""}`}
    autoComplete={autoComplete}
    autoFocus={autoFocus}
    required={required}
    {...rest}
  />
);

export const SubmitButton = ({ value, id, className, style }) => (
  <input
    type="submit"
    name="commit"
    value={value}
    id={id}
    className={`btn-session${className ? ` ${className}` : ""}`}
    style={style}
  />
);

export const PasswordConfirmationFields = ({
  passwordPlaceholder,
  confirmationPlaceholder,
  autoFocus = false
}) => (
  <>
    <div>
      <SessionField
        type="password"
        name="user[password]"
        id="user_password"
        placeholder={passwordPlaceholder}
        required
        autoFocus={autoFocus}
      />
    </div>
    <div>
      <SessionField
        type="password"
        name="user[password_confirmation]"
        id="user_password_confirmation"
        placeholder={confirmationPlaceholder}
        required
      />
    </div>
  </>
);
